<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="500"
        absolute
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-subtitle class="pt-1 pb-1">
                    <span class="font-weight-bold">Datos de deuda</span>
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text v-if="selectedDebt">
                    <template>
                        <v-row>
                            <v-col cols="7">
                                <div class="d-table table-debt-data">
                                    <div class="d-table-row">
                                        <div class="d-table-cell">
                                            <span class="font-weight-medium">Nro Pedido</span>
                                        </div>
                                        <div class="d-table-cell text-right">
                                            <span>#{{ selectedDebt.order_id | numberOrder }}</span>
                                        </div>
                                    </div>
                                    <div class="d-table-row">
                                        <div class="d-table-cell">
                                            <span class="font-weight-medium">Fecha</span>
                                        </div>
                                        <div class="d-table-cell text-right">
                                            <span>{{ selectedDebt.entry_date | moment("DD/MM/YYYY") }}</span>
                                        </div>
                                    </div>
                                    <div class="d-table-row">
                                        <div class="d-table-cell">
                                            <span class="font-weight-medium">Hora</span>
                                        </div>
                                        <div class="d-table-cell text-right">
                                            <span>{{ selectedDebt.entry_date | moment("h:mm a") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="5">
                                <div class="d-table table-debt-data">
                                    <div class="d-table-row">
                                        <div class="d-table-cell">
                                            <span class="font-weight-medium">Monto Deuda</span>
                                        </div>
                                        <div class="d-table-cell text-right">
                                            <span>{{ selectedDebt.amount | currency('S/') }}</span>
                                        </div>
                                    </div>
                                    <div class="d-table-row">
                                        <div class="d-table-cell">
                                            <span class="font-weight-medium">Monto Pagado</span>
                                        </div>
                                        <div class="d-table-cell text-right">
                                            <span class="text-green">{{ selectedDebt.amount_paid | currency('S/')  }}</span>
                                        </div>
                                    </div>
                                    <div class="d-table-row">
                                        <div class="d-table-cell ">
                                            <span class="font-weight-medium">Monto Pediente</span>
                                        </div>
                                        <div class="d-table-cell text-right">
                                            <span class="text-red">{{ selectedDebt.amount_pending | currency('S/') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <v-card class="mt-3">
                <v-card-subtitle class="pt-1 pb-1">
                    <span class="font-weight-bold">Datos del pago</span>
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="4">
                                <span>Importe a pagar</span>
                            </v-col>
                            <v-col cols="8">
                                <v-text-field
                                    outlined
                                    solo
                                    dense
                                    hide-details
                                    prefix="S/"
                                    placeholder="0"
                                    type="number"
                                    v-model="amount_payment"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <span>Observaciones</span>
                            </v-col>
                            <v-col cols="8">
                                <v-textarea
                                outlined
                                solo
                                rows="5"
                                v-model="observation"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>

            <div class="mt-3" style="text-align: right;">    
                <template>
                    <v-row>
                        <v-col cols="6">
                            <v-btn @click="handleCancel" 
                                block 
                                height="45" 
                                dark
                                color="red">
                                Cancelar
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn dark
                                :disabled="press_button"
                                color="green" 
                                block 
                                height="45" 
                                @click="handleRegisterPayment">
                                Pagar
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </div>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'PayDebt',
    data() {
        return {
            titleForm: '',
            drawer: false,
            amount_payment: null,
            observation: null,
            press_button: false
        }
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ]),
        ...mapState('debts', [
            'selectedDebt',
        ])
    },
    methods:{
        ...mapActions('debts', [
            'getDebtsByCustomer',
            'replaceCustomerDebtInDebtsList',
            'getTotalAmount'
        ]),
        clearData(){
            this.amount_payment = null,
            this.observation = null
        },
        showForm(title) {
            this.clearData()
            this.titleForm = title
            this.drawer = !this.drawer
        },
        handleCancel(){
            this.drawer = false
        },
        handleRegisterPayment(){
            this.press_button=true;
            if (this.amount_payment === null || this.amount_payment <= 0) {
                this.press_button = false;
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'RESULTADO DE PAGO',
                    text: 'Debe ingresar el monto a pagar!'
                });
            } else{
                let validate = this.hasError();
                if (validate.error == true) {
                    this.press_button = false;
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'RESULTADO DE PAGO',
                        text: validate.message
                    });
                } else {
                    let payment = {
                        cash_id: this.cashCurrent.id,
                        debt_id: this.selectedDebt.id,
                        amount_payment: this.amount_payment,
                        observations: this.observation
                    }
                    apiService.registerPaymentDebt(payment).then((response) => {                        
                        let summaryDebtCustomer = response.data.debtCustomer[0]
                        this.drawer = false
                        this.press_button = false;
                        this.getDebtsByCustomer(this.selectedDebt.customer_id)
                        this.replaceCustomerDebtInDebtsList(summaryDebtCustomer)
                        this.getTotalAmount()                       
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'RESULTADO DE ACCIÓN REALIZADA',
                            text: 'El pago se realizó de manera correcta!'
                        });

                    });
                }
            }
        },
        hasError() {
            let error = false;
            let message = null;
            if (parseFloat(this.amount_payment) > parseFloat(this.selectedDebt.amount_pending)) {
                error = true;
                message = 'Monto a pagar sobrepasa la deuda pendiente.'
            }

            return {
                error: error,
                message: message
            }
        }
    }
}
</script>

<style>

.table-debt-data{
    width: 100% !important;
}

</style>